// Get All Groups
export const groups = /* GraphQL */ `
  query (
    $first: Int
    $after: String
    $order: [PlatformGroupSortInput!]
    $where: PlatformGroupFilterInput
  ) {
    groups(first: $first, after: $after, order: $order, where: $where) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          displayName
          id
          createWorkGroup
        }
      }
    }
  }
`;
